import { userInfoSync } from 'hub-http/userInfo';
import Raven from 'raven-js';
import enviro from 'enviro';

export const isUngated = (gateName: string) => {
  try {
    const userInfo = userInfoSync();

    return !!userInfo?.gates?.includes(gateName);
  } catch (err: unknown) {
    if (enviro.isQa()) {
      console.error(err);
    }
    Raven.captureException(err as Error, {
      extra: {
        message: 'Error getting user info from `userInfoSync`',
      },
    });
  }

  return false;
};
